import layout from '@/layout'
const meta = { auth: true, cache: true, head: { back: true } }

export default {
  path: '/awsBiz',
  component: layout,
  meta: {
    funcID: 'E0008',
    PID: 'E00',
  },
  children: ((pre) => [
    {
      path: 'replenishment',
      name: `${pre}replenishment`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000801',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/replenishment'),
    },
    {
      path: 'replenishment/:pageType/:code?',
      name: `${pre}replenishment-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzReplenishmentNo = '' } = $route.query || {}
          if (!amzReplenishmentNo) return '店铺补货需求'
          return `店铺补货需求 | ${amzReplenishmentNo}`
        },
        funcID: 'E000801',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/replenishment/detail'),
    },
    {
      path: 'replenishmentConfirm',
      name: `${pre}replenishmentConfirm`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000802',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/replenishmentConfirm'),
    },
    {
      path: 'replenishmentConfirm/:pageType/:code?',
      name: `${pre}replenishmentConfirm-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzReplenishmentNo = '' } = $route.query || {}
          if (!amzReplenishmentNo) return '店铺补货审核'
          return `店铺补货审核 | ${amzReplenishmentNo}`
        },
        funcID: 'E000802',
        PID: 'E00',
      },
      component: () =>
        import('@/views/ecom/awsBiz/replenishmentConfirm/detail'),
    },
    {
      path: 'replenishmentList',
      name: `${pre}replenishmentList`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000803',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/replenishmentList'),
    },
    {
      path: 'replenishmentList/:pageType/:code?',
      name: `${pre}replenishmentList-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzReplenishmentNo = '' } = $route.query || {}
          if (!amzReplenishmentNo) return '补货记录查询'
          return `补货记录查询 | ${amzReplenishmentNo}`
        },
        funcID: 'E000803',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/replenishmentList/detail'),
    },
    {
      path: 'purchaseDemand',
      name: `${pre}purchaseDemand`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000804',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/purchaseDemand'),
    },
    {
      path: 'purchaseDemand/:pageType/:code?',
      name: `${pre}purchaseDemand-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzPurchaseDemandNo = '' } = $route.query || {}
          return amzPurchaseDemandNo || '采购需求单'
        },
        funcID: 'E000804',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/awsBiz/purchaseDemand/detail'),
    },
    {
      path: 'ftyPurchase',
      name: `${pre}ftyPurchase`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000805',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyPurchase'),
    },
    {
      path: 'ftyPurchase/:pageType/:amzPurchaseCode?',
      name: `${pre}ftyPurchase-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzPurchaseNo = '' } = $route.query || {}
          return `工厂采购订单 | ${amzPurchaseNo || 'New'}`
        },
        funcID: 'E000805',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'p-0 bg-transparent' },
          // body: { class: 'pt-0' },
        },
      },
      component: () => import('@/views/ecom/awsBiz/ftyPurchase/detail'),
    },
    {
      path: 'ftyPurchaseChange',
      name: `${pre}ftyPurchaseChange`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000826',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyPurchaseChange'),
    },
    {
      path: 'ftyPurchaseChange/:pageType/:amzPurchaseChangeCode?',
      name: `${pre}ftyPurchaseChange-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzPurchaseNo = '' } = $route.query || {}
          return `采购订单产品变更 | ${amzPurchaseNo || 'New'}`
        },
        funcID: 'E000826',
        PID: 'E00',
        pageConfig: { layout: { class: 'p-0 bg-transparent' } },
      },
      component: () => import('@/views/ecom/awsBiz/ftyPurchaseChange/detail'),
    },
    {
      path: 'ftyInbound',
      name: `${pre}ftyInbound`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000806',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyInbound'),
    },
    {
      path: 'ftyInbound/:pageType/:amzFtyInboundCode?',
      name: `${pre}ftyInbound-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzFtyInboundNo } = $route.query || {}
          if (!amzFtyInboundNo) return '采购入库单'
          return `采购入库单 | ${amzFtyInboundNo}`
        },
        funcID: 'E000806',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/awsBiz/ftyInbound/detail'),
    },
    {
      path: 'fbaShipment',
      name: `${pre}fbaShipment`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000807',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/fbaShipment'),
    },
    {
      path: 'fbaShipment/:pageType/:code?',
      name: `${pre}fbaShipment-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzFbaShipmentNo = '' } = $route.query || {}
          if (!amzFbaShipmentNo) return 'FBA发运单'
          return `FBA发运单 | ${amzFbaShipmentNo}`
        },
        funcID: 'E000807',
        PID: 'E00',
        pageConfig: { layout: { class: 'p-0', bodyClass: 'p-0 m-0' } },
      },
      component: () => import('@/views/ecom/awsBiz/fbaShipment/detail'),
    },
    {
      path: 'amzPeriodSet',
      name: `${pre}amzPeriodSet`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000808',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/amzPeriodSet'),
    },
    {
      path: 'ftyInvCheck',
      name: `${pre}ftyInvCheck`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000809',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyInvCheck'),
    },
    {
      path: 'ftyInvCheck/:pageType/:code?',
      name: `${pre}ftyInvCheck-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzFtyCheckTaskNo = '' } = $route.query || {}
          if (!amzFtyCheckTaskNo) return '工厂库存盘点'
          return `工厂库存盘点 | ${amzFtyCheckTaskNo}`
        },
        funcID: 'E000809',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0' },
        },
      },
      component: () => import('@/views/ecom/awsBiz/ftyInvCheck/detail'),
    },
    {
      path: 'ftyInvInNotice',
      name: `${pre}ftyInvInNotice`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000810',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyInvInNotice'),
    },
    {
      path: 'ftyInvInNotice/:pageType/:amzFtyNoticeInCode?',
      name: `${pre}ftyInvInNotice-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzFtyNoticeInNo, amzFtyNoticeOutNo } = $route.query || {}
          if (!amzFtyNoticeInNo && !amzFtyNoticeOutNo) return '入库通知单'
          if (amzFtyNoticeInNo) return `入库通知单 | ${amzFtyNoticeInNo}`
          if (amzFtyNoticeOutNo) return `生成入库 | ${amzFtyNoticeOutNo}`
        },
        funcID: 'E000810',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/awsBiz/ftyInvInNotice/detail'),
    },
    {
      path: 'ftyInvOutNotice',
      name: `${pre}ftyInvOutNotice`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000811',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyInvOutNotice'),
    },
    {
      path: 'ftyInvOutNotice/:pageType/:amzFtyNoticeOutCode?',
      name: `${pre}ftyInvOutNotice-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzFtyNoticeOutNo } = $route.query || {}
          if (!amzFtyNoticeOutNo) return '出库通知单'
          return `出库通知单 | ${amzFtyNoticeOutNo}`
        },
        funcID: 'E000811',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/awsBiz/ftyInvOutNotice/detail'),
    },
    {
      path: 'ftyOutbound',
      name: `${pre}ftyOutbound`,
      meta: {
        ...meta,
        funcID: 'E000812',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyOutbound'),
    },
    {
      path: 'ftyOutbound/:pageType/:amzFtyOutboundCode?',
      name: `${pre}ftyOutbound-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzFtyOutboundNo } = $route.query || {}
          if (!amzFtyOutboundNo) return '出库发货单'
          return `出库发货单 | ${amzFtyOutboundNo}`
        },
        funcID: 'E000812',
        PID: 'E00',
        pageConfig: {
          layout: { class: 'bg-transparent p-0', bodyClass: 'p-0 m-0' },
        },
      },
      component: () => import('@/views/ecom/awsBiz/ftyOutbound/detail'),
    },

    {
      path: 'replenishmentPurchaseReply',
      name: `${pre}replenishmentPurchaseReply`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000813',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/replenishmentPurchaseReply'),
    },
    {
      path: 'replenishmentPurchaseReply/:pageType/:amzReplenishmentCode?',
      name: `${pre}replenishmentPurchaseReply-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzReplenishmentNo } = $route.query || {}
          if (!amzReplenishmentNo) return '补货采购返答'
          return `补货采购返答 | ${amzReplenishmentNo}`
        },
        funcID: 'E000813',
        PID: 'E00',
      },
      component: () =>
        import('@/views/ecom/awsBiz/replenishmentPurchaseReply/detail'),
    },
    {
      path: 'operateReplyConfirm',
      name: `${pre}operateReplyConfirm`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000814',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/operateReplyConfirm'),
    },
    {
      path: 'operateReplyConfirm/:pageType/:amzReplenishmentCode?',
      name: `${pre}operateReplyConfirm-detail`,
      meta: {
        ...meta,
        title: ({ $route }) => {
          const { amzReplenishmentNo } = $route.query || {}
          if (!amzReplenishmentNo) return '运营返答确认'
          return `运营返答确认 | ${amzReplenishmentNo}`
        },
        funcID: 'E000814',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/operateReplyConfirm/detail'),
    },
    {
      path: 'fbaInvMonitor',
      name: `${pre}fbaInvMonitor`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000815',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/fbaInvMonitor'),
    },
    {
      path: 'awsExpense',
      name: `${pre}awsExpense`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000816',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/awsExpense'),
    },
    {
      path: 'awsExpense/:pageType/:code?',
      name: `${pre}awsExpense-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { amzExpenseNo = '' } = $route.query || {}
          if (amzExpenseNo) {
            return `Amazon费用填报 | ${amzExpenseNo}`
          }
          return 'Amazon费用填报'
        },
        funcID: 'E000816',
        PID: 'E00',
        pageConfig: { layout: { class: 'p-0', bodyClass: 'p-0 m-0' } },
      },
      component: () => import('@/views/ecom/awsBiz/awsExpense/detail'),
    },
    {
      path: 'skuOrderMonitor',
      name: `${pre}skuOrderMonitor`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000817',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuOrderMonitor'),
    },
    {
      path: 'skuOrderMonitor/:pageType/:code?',
      name: `${pre}skuOrderMonitor-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { amzFlipOrderNo = '' } = $route.query || {}
          if (amzFlipOrderNo) {
            return `SKU翻单监控 | ${amzFlipOrderNo}`
          }
          return 'SKU翻单监控'
        },
        funcID: 'E000817',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuOrderMonitor/detail'),
    },
    {
      path: 'skuFlipReview',
      name: `${pre}skuFlipReview`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000818',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFlipReview'),
    },
    {
      path: 'skuFlipReview/:pageType/:code?',
      name: `${pre}skuFlipReview-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { amzFlipOrderNo = '' } = $route.query || {}
          if (amzFlipOrderNo) {
            return `SKU翻单审核 | ${amzFlipOrderNo}`
          }
          return 'SKU翻单审核'
        },
        funcID: 'E000818',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFlipReview/detail'),
    },
    {
      path: 'skuFirstOrder',
      name: `${pre}skuFirstOrder`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000819',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFirstOrder'),
    },
    {
      path: 'skuFirstOrder/:pageType/:amzFirstDemandCode?',
      name: `${pre}skuFirstOrder-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { amzFirstDemandNo = '' } = $route.query || {}
          return `新品首单需求 | ${amzFirstDemandNo || 'New'}`
        },
        funcID: 'E000819',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFirstOrder/detail'),
    },
    {
      path: 'skuFirstOrderPurchase',
      name: `${pre}skuFirstOrderPurchase`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000820',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFirstOrderPurchase'),
    },
    {
      path: 'fbaFlipOrderPurchase',
      name: `${pre}fbaFlipOrderPurchase`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000821',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/fbaFlipOrderPurchase'),
    },
    {
      path: 'queryFtyPurchaseGoods',
      name: `${pre}queryFtyPurchaseGoods`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000822',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/queryFtyPurchaseGoods'),
    },
    {
      path: 'skuFirstOrderReview',
      name: `${pre}skuFirstOrderReview`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000823',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFirstOrderReview'),
    },
    {
      path: 'skuFirstOrderReview/:pageType/:amzFirstDemandCode?',
      name: `${pre}skuFirstOrderReview-detail`,
      meta: {
        ...meta,
        cache: true,
        head: true,
        title: ({ $route }) => {
          const { amzFirstDemandNo = '' } = $route.query || {}
          return `首单需求审核 | ${amzFirstDemandNo || 'New'}`
        },
        funcID: 'E000823',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFirstOrderReview/detail'),
    },
    {
      path: 'ftyPurchaseInv',
      name: `${pre}ftyPurchaseInv`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000824',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/ftyPurchaseInv'),
    },
    {
      path: 'skuDeliveryQuery',
      name: `${pre}skuDeliveryQuery`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000825',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuDeliveryQuery'),
    },
    {
      path: 'skuFirstOrderDashboard',
      name: `${pre}skuFirstOrderDashboard`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000827',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/skuFirstOrderDashboard'),
    },
    {
      path: 'fbaFlipOrderDashboard',
      name: `${pre}fbaFlipOrderDashboard`,
      meta: {
        ...meta,
        head: { back: false },
        funcID: 'E000828',
        PID: 'E00',
      },
      component: () => import('@/views/ecom/awsBiz/fbaFlipOrderDashboard'),
    },
  ])('ecom-awsBiz-'),
}
